module.exports = __webpack_public_path__ + "img/trip-island.094bbba6.png";